wbApp.controller('SelectWeekDateRangeDlg', ['$scope',
function ($scope, groupSvc) {

    $scope.onCancel = function () {
        $scope.$hide();
        $scope.onCanceled();
    }

    $scope.onDetailSave = function (model) {

        $scope.$hide();
        $scope.onSaved($scope.model);
    }
}]);
